import { createContext, useContext } from 'react';
export var FullscreenContext = /*#__PURE__*/createContext(undefined);
export var useFullscreenContext = function useFullscreenContext() {
  var context = useContext(FullscreenContext);
  if (context === undefined) {
    throw new Error('useFullscreenContext must be used within a FullscreenProvider component');
  }
  return context;
};